<template>
    <div class="resolution_block resolution " >
        <!-- INIT USER-->
        <r_table :is_load="is_load" :items="init"  title="Ініціатор" type="init"></r_table>
        <r_table :is_load="is_load" :items="adjust" title="Погодження" type="adjust"></r_table>
        <r_table :is_load="is_load" :items="recipient" title="Затвердження" type="rec"></r_table>
        
        <div class="invoice_show info invoice">
            Повiдомлення
            <i class="fa show_inv" :class="invoice_class" @click="show_invoices"></i>
        </div>
        
        <r_table :is_load="false" :show_head=true :items="invoices" title="INV" type="invoice"></r_table>
        <r_table :is_load="is_load" :items="isp" title="Виконавець прийняв в роботу" type="isp_accept"></r_table>
        <!-- DELEGATE USER -->
        <r_table :is_load="is_load" :items="delegate" v-if="delegate.length > 0" title="Делегування" type="delegates"></r_table>
        <r_table :is_load="is_load" :items="isp_end" title="Виконавець виконав" type="isp_end"></r_table>
        <table class="table-striped table resolution table-responsive-xl">
            <tbody>
                <tr class="info">
                    <td colspan="4" style="">Всього</td>
                    <td class="user_time">{{full_time}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import resolution_table from "./table/resolution_table.vue";

export default {
    name: "tab_resolution",
    components : {
        r_table : resolution_table
    },
    
    created() {
        
        EventBus.$on('refresh_tabs', e => {
            console.log('REFRESH_CALLED', e);
            this.refresh_tab(e);
        });
        
        this.getItems();
    },
    props: {
        doc_id: {
            type: Number,
            required: true
        },
    },
    
    data() {
        return {
            is_load :false,
            
            inv_class : 'fa-angle-double-right',
            inv_show : false,
            init: [],
            adjust: [],
            recipient : [],
            invoice : [],
            delegate : [],
            isp : [],
            isp_end : [],
            invoices : [],
            full_time : '',
            
        }
    },
    computed: {
        invoice_class() {
            if(this.inv_show) {
                return 'fa-angle-double-down';
            }
            
            return 'fa-angle-double-right';
        }
    },
    methods: {
        show_loading(flag) {
            this.is_load = flag;
            this.$store.dispatch('memorandum_work_tabs/SET_MEM_LOAD_TAB', {
                type: this.$options.name,
                active: flag
            });
        },
        refresh_tab (e) {
            if(e.tabs.length > 0) {
                
                let self = this;
                e.tabs.forEach(tab => {
                    if(tab === this.$options.name) {
                        this.init = [];
                        this.isp = [];
                        this.delegate = [];
                        this.adjust = [];
                        this.recipient = [];
                        this.invoice = [];
                        this.isp = [];
                        this.isp_end = [];
                        
                        self.getItems();
                        self.getInvocies();
                    }
                })
            }
        },
        show_invoices() {
            
            if(!this.inv_show) {
                this.getInvocies();
                this.inv_show = true;
            }else {
                this.invoices = [];
                this.inv_show = false;
            }
            
        },
        
        async getInvocies() {
            this.invoices = [];
            await api.get('/memorandums/'+ this.doc_id + "/invoices").then(({data}) => {
                if (data.status === "operation_success") {
                    let resp = data.data;
                    if(resp.hasOwnProperty("full")) {
                        this.invoices = resp.full.map(item => {
                            item.user_image = item.medium_img;
                            return item;
                        });
                    }
                }
            });
        },
        
        async getItems() {
            this.show_loading(true);
            await api.get('/memorandums/'+ this.doc_id + "/resolutions").then(({data}) => {
                if (data.status === "operation_success") {
                    
                    let res = data.data;
                    let simple_users = {};
                    let adjust_users = [];
                    
                    if(res.hasOwnProperty('simple_users')) {
                        simple_users = res.simple_users;
                    }
                    
                    //All info
                    if(this.obj_to_null(res.full_time)) {
                        this.full_time = res.full_time;
                    }
                    
                    //Init User
                    if(this.obj_to_null(simple_users.init_user)) {
                        this.init.push(simple_users.init_user.info);
                    }
                    
                    //Rec User
                    if(this.obj_to_null(simple_users.rec_user)) {
                        
                        let rec = JSON.parse(JSON.stringify(simple_users.rec_user.info)); ;
                        rec.cur_right = simple_users.rec_user.cur_right;
                        rec.mem_id    = simple_users.rec_user.mem_id;
                        
                        this.recipient.push(rec);
                    }
                    
                    //ISP User
                    if(this.obj_to_null(simple_users.isp_user)) {
                        
                        let isp = JSON.parse(JSON.stringify(simple_users.isp_user.info));
                        
                        isp.cur_right = simple_users.isp_user.cur_right;
                        isp.mem_id    = simple_users.isp_user.mem_id;
                        
                        
                        if(simple_users.isp_user.hasOwnProperty("end")) {
                            let isp_end = JSON.parse(JSON.stringify(simple_users.isp_user.end));
                            
                            isp_end.cur_right = simple_users.isp_user.cur_right;
                            isp_end.mem_id = simple_users.isp_user.mem_id;
                            isp_end.user_id = simple_users.isp_user.info.user_id;
                           // isp_end.class = simple_users.isp_user.info.class;
                            
                            this.isp_end.push(isp_end);
                        }
                        
                        this.isp.push(isp);
                     
                    }
                    
                    //Adjusts
                    if(this.obj_to_null(res.adjust_list)) {
                        this.adjust = res.adjust_list;
                    }
                    
                    //Delegate
                    if(this.obj_to_null(res.delegated_list)) {
                        this.delegate = res.delegated_list;
                    }
                    
                    this.items = data.message;
                    this.show_loading(false);
                    
                }
            }).catch(err => {
                this.show_loading(false);
                console.error("ERR:",err);
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
    },
    
}
</script>

<style scoped>



</style>
